<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">修改官方面料信息</h1>
    <div class="content-wrap">
      <!-- 左侧面料表单区域 input输入框 -->
      <div class="left-form">
        <div class="form-item" style="width: 230px; margin-left: 14px">
          <label require>品名编号:</label>
          <el-input v-model="formData.productNo" placeholder=""></el-input>
        </div>
        <div class="form-item two-col-wrap">
          <div class="form-item-inline">
            <label>幅宽:</label>
            <el-input type="text" v-model="formData.width"></el-input
            ><span>cm</span>
          </div>
          <div class="form-item-inline">
            <label>克重:</label>
            <el-input type="text" v-model="formData.weight"></el-input
            ><span style="font-size: 15px">g/㎡</span>
          </div>
        </div>
        <div class="form-item" style="width: 230px">
          <label>量化:</label>
          <el-input v-model="formData.quantify"></el-input> <span>m/kg</span>
        </div>
        <div class="form-item" style="width: 230px">
          <label>成分:</label>
          <el-input v-model="formData.composition"></el-input>
        </div>
        <div class="form-item two-col-wrap">
          <div class="form-item-inline">
            <label>纱支:</label>
            <el-input v-model="formData.yarnCount"></el-input>
          </div>
          <div class="form-item-inline">
            <label>密度:</label>
            <el-input v-model="formData.density"></el-input>
          </div>
        </div>
        <div class="form-item" style="width: 230px">
          <label>规格:</label>
          <el-input v-model="formData.spec"></el-input>
        </div>
        <div class="form-item" style="width: 420px">
          <label>备注:</label>
          <el-input v-model="formData.remark"></el-input>
        </div>
      </div>
      <!-- 右侧供应商表格区域 -->
      <div class="right-table-wrap">
        <div class="table-header">
          <h2 class="table-title">面料供应商信息</h2>
          <div class="header-btns">
            <el-button class="publish-btn" size="small" @click="addSupplier"
              >添加供应商</el-button
            >
            <el-button class="publish-btn" size="small" @click="save"
              >修改</el-button
            >
          </div>
        </div>
        <el-table :data="showSupplierList" border style="width: 100%">
          <el-table-column prop="name" label="商家名" width="200">
            <template #default="{ row }">
              <el-input v-model="row.name"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="memberProductName"
            label="商家产品编号"
            width="200"
          >
            <template #default="{ row }">
              <el-input v-model="row.memberProductName"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="录入时间" max-width="200">
            <template #default="{ row }">
              <el-date-picker
                v-model="row.date"
                type="date"
                placeholder="选择日期"
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                style="width: 100%; padding: 0px 40px"
                :teleport="true"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template #default="{ $index }">
              <el-button type="text" @click="delSupplier($index)">×</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script setup>
/*global defineProps,defineEmits*/
import { ref, reactive, computed, watch, getCurrentInstance } from "vue";
const { proxy } = getCurrentInstance();
const props = defineProps({
  row: {
    type: Object,
    default: null,
  },
});
// emit
const emit = defineEmits(["update-success"]);

const editId = ref("");
const formData = reactive({
  productNo: "",
  width: "",
  weight: "",
  quantify: "",
  composition: "",
  yarnCount: "",
  density: "",
  spec: "",
  remark: "",
});
const supplierList = reactive([]);

// 计算属性：过滤delflag !==0
const showSupplierList = computed(() => {
  return supplierList.filter((item) => item.delflag !== 0);
});

// 监听props.row，immediate:true，和vue2完全一致
watch(
  () => props.row,
  (val) => {
    if (!val) {
      del();
      return;
    }
    formData.productNo = val.name || "";
    editId.value = val.id || "";
    formData.width = val.width?.replace(/cm/g, "").trim() || "";
    formData.weight = val.weight?.replace(/["]?g\/㎡/g, "").trim() || "";
    formData.quantify = val.quantify?.replace(/["]?m\/kg/g, "").trim() || "";
    formData.composition = val.ingredients || "";
    formData.yarnCount = val.yarnCount || "";
    formData.density = val.density || "";
    formData.spec = val.specification || "";
    formData.remark = val.remark || "";
    const rawList = val.supplierList
      ? JSON.parse(JSON.stringify(val.supplierList))
      : [];
    supplierList.length = 0;
    supplierList.push(
      ...rawList.map((item) => {
        return {
          delflag: item.delflag ?? 1,
          ...item,
        };
      })
    );
  },
  { immediate: true }
);

//新增供应商
const addSupplier = () => {
  supplierList.push({
    name: "",
    memberProductName: "",
    date: proxy.$day(new Date()).format("YYYY-MM-DD"),
    delflag: 1,
  });
};

const delSupplier = (showIndex) => {
  // showIndex 是表格过滤后数组下标，要找到原始supplierList对应那一条
  const visible = supplierList.filter((x) => x.delflag !== 0);
  const targetRow = visible[showIndex];
  if (!targetRow) return;
  // 在原始数组找到同一个对象，设置delflag=0，对象不移除
  const originItem = supplierList.find((o) => o === targetRow);
  if (originItem) {
    originItem.delflag = 0;
  }
  console.log("原始完整supplierList", JSON.parse(JSON.stringify(supplierList)));
};

const del = () => {
  editId.value = "";
  formData.productNo = "";
  formData.width = "";
  formData.weight = "";
  formData.quantify = "";
  formData.composition = "";
  formData.yarnCount = "";
  formData.density = "";
  formData.spec = "";
  formData.remark = "";
  supplierList.length = 0;
};

const save = async () => {
  if (formData.productNo == "") {
    proxy.$message.warning("品名编号不能为空");
    return;
  }
  const sendata = {
    id: editId.value,
    width: formData.width == "" ? formData.width : formData.width + "cm",
    name: formData.productNo,
    weight: formData.weight == "" ? formData.weight : formData.weight + "g/㎡",
    ingredients: formData.composition,
    quantify:
      formData.quantify == "" ? formData.quantify : formData.quantify + "m/kg",
    remark: formData.remark,
    yarnCount: formData.yarnCount,
    density: formData.density,
    specification: formData.spec,
    supplierList: supplierList,
  };
  console.log("提交sendata", JSON.parse(JSON.stringify(sendata)));
  const res = await proxy.$api.Operation.Baseproduct.update(sendata);
  if (res.data.code == "200") {
    emit("update-success");
    del();
  } else {
    proxy.$message.error(res.data.msg || "网络错误");
  }
};
</script>

<style lang="scss" scoped>
@import "./user-product-launch.scss";
.panel-title {
  color: #999;
}
.content-wrap {
  display: flex;
  gap: 30px;
  margin-top: 20px;
  border: 1px solid #ccc;
  padding: 24px;
}
.left-form {
  width: 400px;
  .form-item {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    label {
      width: 80px;
      flex-shrink: 0;
      font-size: 15px;
      text-align: center;
    }
    :deep(.el-input) {
      flex: 1;
    }
  }
  .two-col-wrap {
    gap: 16px;
    .form-item-inline {
      display: flex;
      align-items: center;
      flex: 1;
      label {
        width: 80px;
        flex-shrink: 0;
      }
      :deep(.el-input) {
        flex: 1;
      }
    }
  }
}
.right-table-wrap {
  flex: 1;
  .table-header {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 12px;
    .table-title {
      font-size: 22px;
      font-weight: normal;
      margin: 0;
    }
    .header-btns {
      position: absolute;
      right: 0;
      display: flex;
      gap: 8px;
    }
  }
  :deep(.el-input__inner) {
    padding: 0 8px;
  }
  :deep(.el-date-picker) {
    width: 100%;
  }
  :deep(.el-date-picker__wrapper) {
    padding-right: 34px !important;
  }
}

.publish-btn {
  background-color: #ff9900;
}
</style>
